export default function Imprint() {
  return (
    <main className="w-full bg-white min-h-screen pt-40 pb-24 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-transparent to-white pointer-events-none" />
      <div className="container mx-auto px-6 md:px-12 max-w-4xl relative z-10">
        <div className="mb-12 border-b border-border pb-8">
          <span className="font-mono text-primary text-sm tracking-[0.3em] uppercase block mb-4">
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-light text-foreground">
            Legal <span className="font-bold">Imprint</span>
          </h1>
        </div>
        
        <div className="prose prose-p:text-muted-foreground prose-p:leading-relaxed prose-headings:font-bold prose-headings:text-foreground prose-a:text-primary hover:prose-a:text-primary/80 max-w-none">
          <p>Information according to § 5 TMG / § 14 UGB / § 24 Media Act.</p>

          <h2>Plasmics GmbH</h2>
          <p>
            <strong>Headquarters:</strong><br />
            Vienna, Austria<br />
            (Specific address details available upon formal request or as required by local registry)
          </p>

          <h3>Contact</h3>
          <p>
            <strong>Email:</strong> office@plasmics.com<br />
            <strong>Website:</strong> www.plasmics.com
          </p>

          <h3>Company Register</h3>
          <p>
            <strong>Commercial Register Court:</strong> Handelsgericht Wien<br />
            <strong>Company Registration Number:</strong> [Placeholder Number]<br />
            <strong>VAT ID (UID):</strong> ATU[Placeholder]
          </p>

          <h3>Managing Directors</h3>
          <p>
            Management team details available via the Austrian commercial register.
          </p>

          <h2>Disclaimer</h2>
          
          <h3>Liability for Content</h3>
          <p>
            As a service provider, we are responsible for our own content on these pages in accordance with general laws. We are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general law remain unaffected. However, liability in this regard is only possible from the moment of knowledge of a specific infringement. Upon notification of such violations, we will remove the content immediately.
          </p>

          <h3>Copyright</h3>
          <p>
            The content and works created by the site operators on these pages are subject to Austrian copyright law. Duplication, processing, distribution, and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator. Downloads and copies of this site are only permitted for private, non-commercial use.
          </p>
        </div>
      </div>
    </main>
  );
}
